import $ from "jquery";
/* Banner Cookie */
$(document).ready(function(){
	var callback = function(){
		// Handler when the DOM is fully loaded
		const appRoot = document.getElementsByTagName('body')[0];
		appRoot.addEventListener('click', ePasswordToggle, false);
	};
	
	if (
		document.readyState === "complete" ||
		(document.readyState !== "loading" && !document.documentElement.doScroll)
	) {
		callback();
	} else {
		document.addEventListener("DOMContentLoaded", callback);
	}

	function ePasswordToggle() {
																				// console.log(event);
		// var targetAction = event.target.dataset;
		if(event.target.className == 'password-toggle') {
			let thisPasswordContainer = event.target.parentElement;
																				// console.log(thisPasswordContainer);
			let thisInput = thisPasswordContainer.querySelector('input');
																				// console.log(thisInput);
			if(thisInput.getAttribute('type') == 'password') {
				thisInput.setAttribute('type', 'text');
			}
			else {
				thisInput.setAttribute('type', 'password');
			}

		}
	}

	function mutationListener() {

		const nodeList = document.querySelectorAll('.e-data-input-feedback');
		// console.log(nodeList);
		if (nodeList) {
			function callback(mutationsList, observer) {
				// console.log('Mutations:', mutationsList)
				// console.log('Observer:', observer)
				mutationsList.forEach(mutation => {
					if (mutation.attributeName === 'class') {
						// console.log(mutation.target);
						let thisMutant = mutation.target;
						if (thisMutant.classList.contains("field-validation-error")) {
							inputHasError(mutation.target);
						}
						else if (thisMutant.classList.contains("field-validation-valid")) {
							inputIsValid(mutation.target);
						}
					}
				})
			}

			const mutationObserver = new MutationObserver(callback)

			if (nodeList) {
				for (let i=0; i < nodeList.length; i++) {
					mutationObserver.observe(nodeList[i], { attributes: true })
				}
			}

			function inputHasError(target) {
				let targetWrap = target.closest('.e-data-input-wrap');
				targetWrap.classList.add('error');
			}
			function inputIsValid(target) {
				let targetWrap = target.closest('.e-data-input-wrap');
				targetWrap.classList.remove('error');
			}

		}	
	}
	mutationListener();

});